export const GET_APPOINTMENT_TYPES_REQUEST = 'GET_APPOINTMENT_TYPES_REQUEST';
export const GET_APPOINTMENT_TYPES_FAILURE = 'GET_APPOINTMENT_TYPES_FAILURE';
export const GET_APPOINTMENT_TYPES_SUCCESS = 'GET_APPOINTMENT_TYPES_SUCCESS';
